import { ISesionApp, SesionApp } from "@/core/model/sesion/ISesionApp";
import IParamServices from "../IParamServices";
import BaseService from "../base/BaseService";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { eRolAppUsuario, eStatusCode } from "@/core/model/GloblasEnum";
import localforage from "localforage";
import { IAppUserSettings } from "../sys/AppSystemSettingsService";

export default class LoginService extends BaseService
{
  protected AppSessionName = 'AppSession';
  protected AppSessionSettingsName = 'AppSessionSettings';
  constructor(param: IParamServices)
  {
    super(param);
  } 
  public isFreePath(to:any, freePaths:any): boolean
  {               
    const isFree = freePaths.find((c:any) => c === to.name);      
    return isFree? true:false;      
  }         
  public canUserAccess(sesion: ISesionApp|null,to:any,RoutesRol:any): boolean
  {                 
    const withRol = RoutesRol.find((c:any) => c.name === to.name);
    if(withRol)
    {      
      if(!sesion || !sesion.Type)  
      return false;
      let hasRol = false;
      for (const rolMenu of withRol.Rol)
      {
        if(rolMenu === sesion.Type)
        {
          hasRol = true;                    
          break;
        }
      }      
      const allow =  hasRol && sesion.canAccess();      
      return allow;
    }
    else
    {
      //console.log('sin rol ' + to.name);
      return sesion? sesion.canAccess() : false;
    }
  }
  protected async setStoreElement(name: string, content?: string):Promise<void>
  {    
    await localforage.setItem(name, content);    
  }
  protected async getStoreElement(name: string):Promise<string|null>
  {    
    return await localforage.getItem<string>(name);                 
  }
  public async SesionEmpleado(sesion:ISesionApp):Promise<ISesionApp>
  {   
    const appSettings:IAppUserSettings = {
      profileImg:sesion.Employee?.User.Photo?sesion.Employee?.User.Photo:'',
      theme:sesion.Employee?.User.Theme?sesion.Employee?.User.Theme:'',
      language:sesion.Employee?.User.Language?sesion.Employee?.User.Language:'es-mx'};
    await this.SaveSession(sesion);
    await this.SaveAppSettings(appSettings);
    return sesion;
  }    
  public async SesionCliente(sesion:ISesionApp):Promise<ISesionApp>
  {   
    if(sesion.Cliente?.User)
    {
    const appSettings:IAppUserSettings = {
      profileImg:sesion.Cliente?.User.Photo?sesion.Cliente?.User.Photo:'',
      theme:sesion.Cliente?.User.Theme?sesion.Cliente?.User.Theme:'',
      language:sesion.Cliente?.User.Language?sesion.Cliente?.User.Language:'es-mx'};
    await this.SaveSession(sesion);
    await this.SaveAppSettings(appSettings);
    }
    return sesion;
  }     
  public async CloseSesion()
  {
    await localforage.removeItem(this.AppSessionName);  
  }
  public async SaveAppSettings(settings:IAppUserSettings):Promise<void>
  {    
    await this.setStoreElement(this.AppSessionSettingsName,JSON.stringify(settings));     
  }
  public async getAppSettings():Promise<IAppUserSettings>
  {
    const val:string|null|undefined = await this.getStoreElement(this.AppSessionSettingsName);    
    const appSettings:IAppUserSettings|null = val? JSON.parse(val):null;    
    return appSettings? appSettings:{ profileImg:'',theme:'',language:'es-mx'};  
  }  
  protected async SaveSession(sesion:ISesionApp):Promise<void>
  {    
    await this.setStoreElement(this.AppSessionName,JSON.stringify(sesion));     
  }           
  public async getSession():Promise<ISesionApp>
  {
    const val:string|null|undefined = await this.getStoreElement(this.AppSessionName);    
    const sesion:ISesionApp|null = val? new SesionApp(JSON.parse(val)):null;    
    return sesion? sesion:new SesionApp();  
  }
  public async LoginEmployee(user: any,fnEval:any): Promise<ISesionApp|null>
  { 
    let sesion: ISesionApp|null = null;                
    const factory = this.getFactory();
    const cservice = factory.getCService;            
    const usr = { UserName : user.userId,Password : cservice.ToMD5(user.clave),RolAppUsuario:eRolAppUsuario.Empleado};
    const response:IServiceResponse =  await this.Post('Users/Login',usr,null,null,null,true);       
    if(response)
    {
      if(response.Response && response.Response.Error)
      {
        fnEval({tipo: eStatusCode.Error,msg: response.Response.Response});
      }  
      else
      {
        sesion = new SesionApp(response.Response);
      }      
    }    
    return sesion;
  }
  public async LoginSocio(user: any,fnEval:any): Promise<ISesionApp|null>
  { 
    let sesion: ISesionApp|null = null;                
    const factory = this.getFactory();
    const cservice = factory.getCService;            
    const usr = { UserName : user.userId,Password : cservice.ToMD5(user.clave),RolAppUsuario:eRolAppUsuario.Cliente};
    const response:IServiceResponse =  await this.Post('Users/LoginSocio',usr,null,null,null,true);       
    if(response)
    {
      if(response.Response && response.Response.Error)
      {
        fnEval({tipo: eStatusCode.Error,msg: response.Response.Response});
      }  
      else
      {
        sesion = new SesionApp(response.Response);
      }      
    }    
    return sesion;
  }
}